import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { SetTabsWorkbook } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface SetTabsWorkbookAction extends Action {
  workbooks: IContentInfo[];
}

export function setTabs(workbooks: IContentInfo[]): SetTabsWorkbookAction {
  return {
    type: SetTabsWorkbook,
    workbooks
  };
}

const isSetTabsWorkbookAction = isActionFactory<SetTabsWorkbookAction>(SetTabsWorkbook);
